import { render, staticRenderFns } from "./MatrixGroupHeaderCard.vue?vue&type=template&id=7a7a1c3e"
import script from "./MatrixGroupHeaderCard.vue?vue&type=script&lang=js"
export * from "./MatrixGroupHeaderCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports